import { OverlayContent } from '../enums/elementId';
import { showElement, showElements } from '../util/visibility';

export const updateOverlayContent = (activeUI: OverlayContent) => {
    showElements(Object.values(OverlayContent), false);
    showElement(activeUI);
};
